// Compact license-pool stat cards (Total / Available / In use / Revoked).
// Shared by the Users and Licenses tabs; `summary` comes from
// orgApi.listLicenses() → { total, available, inUse, revoked }.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { orgStyles } from './OrgConsole';

export default function LicenseStatCards({ summary }) {
  const { t } = useTranslation('orgAdmin');
  if (!summary) return null;
  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
      {[
        ['total', t('stats.total'), summary.total, 'rgba(27,37,80,0.76)'],
        ['available', t('stats.available'), summary.available, '#26C774'],
        ['inUse', t('stats.inUse'), summary.inUse, '#1AB0F2'],
        ['revoked', t('stats.revoked'), summary.revoked, '#FF5151'],
      ].map(([id, label, n, color]) => (
        <div key={id} style={{ ...orgStyles.card, padding: '10px 18px', textAlign: 'center' }}>
          <div style={{ color, fontSize: '20px', fontWeight: 700 }}>{n}</div>
          <div style={{ ...orgStyles.muted, fontSize: '11px' }}>{label}</div>
        </div>
      ))}
    </div>
  );
}
